import React from "react";
import { ShieldCheck, Truck, BadgeCheck, RefreshCw, Headphones, Lock } from "lucide-react";

const ITEMS = [
  [ShieldCheck, "Secure Checkout", "256-bit SSL encryption"],
  [Truck, "Fast Shipping", "Dispatched within 24h"],
  [BadgeCheck, "100% Authentic", "Guaranteed genuine perfumes"],
  [RefreshCw, "Easy Returns", "30-day hassle-free returns"],
  [Headphones, "Customer Support", "Here for you 7 days a week"],
  [Lock, "Safe & Private", "Your data is protected"],
];

export default function TrustBar({ compact = false }) {
  const items = compact ? ITEMS.slice(0, 4) : ITEMS;
  return (
    <section className="border-y border-[rgba(212,175,55,0.15)] bg-[#0E0E10]" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-5">
        {items.map(([Icon, t, s]) => (
          <div key={t} className="flex items-center gap-3">
            <Icon size={20} className="text-[#D4AF37] shrink-0" />
            <div>
              <p className="text-xs text-[#FAFAF7] leading-tight">{t}</p>
              <p className="text-[0.65rem] text-[#FAFAF7]/45 leading-tight">{s}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
